export default __webpack_public_path__ + "static/media/src_convert7776_mobile_6.b9ffa8af.jpg";